import { Address } from "@/Common/Api/Contacts/Dto/Address";
import { ContactPoint } from "@/Common/Api/Contacts/Dto/ContactPoint";
import { Email } from "@/Common/Api/Contacts/Dto/Email";
import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { Patient } from "@/Common/Api/Patient/Dto/Patient";
import { NameHelper } from "@/Common/Helpers/NameHelper";
import { UserPermissionFlags } from "@/Common/Models/Portal/MedfarPortal";
import { Individual } from "../../Individuals/Dto/Individual";

class LinkedContact {
    public Id: string;
    public RelationLookupId: string;
    public TargetContactId: string;

    public IsRepresentative: boolean;
    public RepresentativeType: string;

    public IsEmergencyContact: boolean;

    public PermissionFlags: UserPermissionFlags;

    // Internal (Base Info)
    public Individual: Individual;
    public Patient: Patient;
    // --------------------

    // Contact Info
    public ContactPoints: ContactPoint[];
    public PhoneNumbers: PhoneNumber[];
    public Addresses: Address[];
    public Emails: Email[];

    // Permissions on the reverse relation
    public ReversePermissionFlags: UserPermissionFlags;

    public static GetNAM(linkedContact: LinkedContact): string {
        return (linkedContact.Individual != null && !IsNullOrWhiteSpace(linkedContact.Individual.NAM)) ?
            linkedContact.Individual.NAM : "";
    }

    public static GetFullName(linkedContact: LinkedContact): string {
        return linkedContact.Individual != null ? NameHelper.formatFullNameForHasName(linkedContact.Individual) : "";
    }

    public static GetFullNameWithPrefix(linkedContact: LinkedContact): string {
        return linkedContact.Individual ? NameHelper.formatFullNameWithPrefixForHasName(linkedContact.Individual) : "";
    }

    public static GetLastName(linkedContact: LinkedContact): string {
        return linkedContact.Individual != null ? linkedContact.Individual.LastName : "";
    }

    public static GetFirstName(linkedContact: LinkedContact): string {
        return linkedContact.Individual != null ? linkedContact.Individual.FirstName : "";
    }

    public static GetDateOfBirth(linkedContact: LinkedContact): Date {
        return linkedContact.Individual != null ? linkedContact.Individual.DateOfBirth : null;
    }
}

export { LinkedContact };
